import React from "react";
import { BrowserRouter, HashRouter, Switch } from "react-router-dom";
import { TanimMusteriNoktaBilgiKart_Screen } from "../screens/tanimmusterinoktabilgikart/tanimmusterinoktabilgikart";
import { ParsiyelMusteriSevkListe_Screen } from "../screens/parsiyelmusterisevkliste/parsiyelmusterisevkliste";
import { ArunaLoading_Screen } from "../screens/arunaloading/arunaloading";
import { YonetimIlceKart_Screen } from "../screens/yonetimilcekart/yonetimilcekart";
import { LeftMenuYukVeren_Screen } from "../screens/leftmenuyukveren/leftmenuyukveren";
import { TanimAracTip_Screen } from "../screens/tanimaractip/tanimaractip";
import { YuklemeListesiv2SpotListesi_Screen } from "../screens/yuklemelistesiv2spotlistesi/yuklemelistesiv2spotlistesi";
import { TanimMusteriNoktaTanim_Screen } from "../screens/tanimmusterinoktatanim/tanimmusterinoktatanim";
import { YuklemeListesiv2EvrakKontrol_Screen } from "../screens/yuklemelistesiv2evrakkontrol/yuklemelistesiv2evrakkontrol";
import { TanimSurucuTanim_Screen } from "../screens/tanimsurucutanim/tanimsurucutanim";
import { YonetimSehirKart_Screen } from "../screens/yonetimsehirkart/yonetimsehirkart";
import { YonetimSehirTanim_Screen } from "../screens/yonetimsehirtanim/yonetimsehirtanim";
import { TanimYuklemeTeslimNoktaListe_Screen } from "../screens/tanimyuklemeteslimnoktaliste/tanimyuklemeteslimnoktaliste";
import { YuklemeBekleyenListe_Screen } from "../screens/yuklemebekleyenliste/yuklemebekleyenliste";
import { TanimMusteriTedarikciTanim_Screen } from "../screens/tanimmusteritedarikcitanim/tanimmusteritedarikcitanim";
import { ParsiyelAracYukleme_Screen } from "../screens/parsiyelaracyukleme/parsiyelaracyukleme";
import { YuklemeListesiv2DetayTedarikci_Screen } from "../screens/yuklemelistesiv2detaytedarikci/yuklemelistesiv2detaytedarikci";
import { YonetimKullaniciTanim_Screen } from "../screens/yonetimkullanicitanim/yonetimkullanicitanim";
import { TeslimatYukle_Screen } from "../screens/teslimatyukle/teslimatyukle";
import { SiparisDetayParsiyel_Screen } from "../screens/siparisdetayparsiyel/siparisdetayparsiyel";
import { YuklemeListesiv2Ozet_Screen } from "../screens/yuklemelistesiv2ozet/yuklemelistesiv2ozet";
import { TanimAracTipListe_Screen } from "../screens/tanimaractipliste/tanimaractipliste";
import { YuklemeListesiv2EvrakKontrolTedarikci_Screen } from "../screens/yuklemelistesiv2evrakkontroltedarikci/yuklemelistesiv2evrakkontroltedarikci";
import { Raporv2UrunSevkiyatPlan_Screen } from "../screens/raporv2urunsevkiyatplan/raporv2urunsevkiyatplan";
import { YonetimIlceTanim_Screen } from "../screens/yonetimilcetanim/yonetimilcetanim";
import { TeslimYuklemeTanim_Screen } from "../screens/teslimyuklemetanim/teslimyuklemetanim";
import { SiparisParsiyelDetayv2_Screen } from "../screens/siparisparsiyeldetayv2/siparisparsiyeldetayv2";
import { RaporFTLMusteriDetayli_Screen } from "../screens/raporftlmusteridetayli/raporftlmusteridetayli";
import { RaporParsiyelYukleme_Screen } from "../screens/raporparsiyelyukleme/raporparsiyelyukleme";
import { SiparisListesiParsiyel_Screen } from "../screens/siparislistesiparsiyel/siparislistesiparsiyel";
import { TanimMusteriTedarikciBilgiKart_Screen } from "../screens/tanimmusteritedarikcibilgikart/tanimmusteritedarikcibilgikart";
import { YuklemeOlusturmaSecimv2_Screen } from "../screens/yuklemeolusturmasecimv2/yuklemeolusturmasecimv2";
import { ParsiyelMusteriSevk_Screen } from "../screens/parsiyelmusterisevk/parsiyelmusterisevk";
import { YuklemeListesiv2EvrakDetay_Screen } from "../screens/yuklemelistesiv2evrakdetay/yuklemelistesiv2evrakdetay";
import { YuklemePlanAracAtama_Screen } from "../screens/yuklemeplanaracatama/yuklemeplanaracatama";
import { TanimUrunTanim_Screen } from "../screens/tanimuruntanim/tanimuruntanim";
import { YuklemeListesi_Screen } from "../screens/yuklemelistesi/yuklemelistesi";
import { TeslimatIrsaliyeBaglaExcel_Screen } from "../screens/teslimatirsaliyebaglaexcel/teslimatirsaliyebaglaexcel";
import { Signin_Screen } from "../screens/signin/signin";
import { HomePage_Screen } from "../screens/homepage/homepage";
import { YonetimUlkeTanim_Screen } from "../screens/yonetimulketanim/yonetimulketanim";
import { YuklemeOlusturmaExcel_Screen } from "../screens/yuklemeolusturmaexcel/yuklemeolusturmaexcel";
import { YuklemeListesiv2_Screen } from "../screens/yuklemelistesiv2/yuklemelistesiv2";
import { TanimAracBilgiKart_Screen } from "../screens/tanimaracbilgikart/tanimaracbilgikart";
import { Raporv2KantarFarkOnay_Screen } from "../screens/raporv2kantarfarkonay/raporv2kantarfarkonay";
import { TanimSurucuBilgiKart_Screen } from "../screens/tanimsurucubilgikart/tanimsurucubilgikart";
import { TanimUrunKarti_Screen } from "../screens/tanimurunkarti/tanimurunkarti";
import { LeftMenu_Screen } from "../screens/leftmenu/leftmenu";
import { YonetimFirmaKart_Screen } from "../screens/yonetimfirmakart/yonetimfirmakart";
import { SiparisListesiParsiyelv2_Screen } from "../screens/siparislistesiparsiyelv2/siparislistesiparsiyelv2";
import { YuklemeTeslimatBilgi_Screen } from "../screens/yuklemeteslimatbilgi/yuklemeteslimatbilgi";
import { TanimNakliyeSicaklik_Screen } from "../screens/tanimnakliyesicaklik/tanimnakliyesicaklik";
import { YuklemePlanAracIslemleri_Screen } from "../screens/yuklemeplanaracislemleri/yuklemeplanaracislemleri";
import { VerificationCode_Screen } from "../screens/verificationcode/verificationcode";
import { Raporv2MikroDagitim_Screen } from "../screens/raporv2mikrodagitim/raporv2mikrodagitim";
import { YonetimFirmaTanim_Screen } from "../screens/yonetimfirmatanim/yonetimfirmatanim";
import { YuklemePlanKantarFarkListesi_Screen } from "../screens/yuklemeplankantarfarklistesi/yuklemeplankantarfarklistesi";
import { Raporv2TedarikciPerformans_Screen } from "../screens/raporv2tedarikciperformans/raporv2tedarikciperformans";
import { RaporLTLMusteriDetayli_Screen } from "../screens/raporltlmusteridetayli/raporltlmusteridetayli";
import { SiparisDetayFullTruck_Screen } from "../screens/siparisdetayfulltruck/siparisdetayfulltruck";
import { RaporLTLMusteriIlDetayli_Screen } from "../screens/raporltlmusteriildetayli/raporltlmusteriildetayli";
import { ForgotPassword_Screen } from "../screens/forgotpassword/forgotpassword";
import { ParsiyelMusteridenMalKabul_Screen } from "../screens/parsiyelmusteridenmalkabul/parsiyelmusteridenmalkabul";
import { YonetimKullaniciEkle_Screen } from "../screens/yonetimkullaniciekle/yonetimkullaniciekle";
import { YonetimUlkeKart_Screen } from "../screens/yonetimulkekart/yonetimulkekart";
import { HomePagecopy_Screen } from "../screens/homepagecopy/homepagecopy";
import { YuklemeListesiv2SpotAktarimListesi_Screen } from "../screens/yuklemelistesiv2spotaktarimlistesi/yuklemelistesiv2spotaktarimlistesi";
import { ParsiyelMusteriSevkListeDetay_Screen } from "../screens/parsiyelmusterisevklistedetay/parsiyelmusterisevklistedetay";
import { Raporv2YuklemeListeOzet_Screen } from "../screens/raporv2yuklemelisteozet/raporv2yuklemelisteozet";
import { Signup_Screen } from "../screens/signup/signup";
import { SiparisSevkEmriDetay_Screen } from "../screens/siparissevkemridetay/siparissevkemridetay";
import { BarkodListesi_Screen } from "../screens/barkodlistesi/barkodlistesi";
import { YuklemePlanDetay_Screen } from "../screens/yuklemeplandetay/yuklemeplandetay";
import { YuklemePlanSpotTeklifVer_Screen } from "../screens/yuklemeplanspotteklifver/yuklemeplanspotteklifver";
import { LeftMenuBos_Screen } from "../screens/leftmenubos/leftmenubos";
import { YuklemePlanSpotTeklifler_Screen } from "../screens/yuklemeplanspotteklifler/yuklemeplanspotteklifler";
import { TanimAracTanim_Screen } from "../screens/tanimaractanim/tanimaractanim";
import { ParsiyelDatMalKabul_Screen } from "../screens/parsiyeldatmalkabul/parsiyeldatmalkabul";
import { MesajGoster_Screen } from "../screens/mesajgoster/mesajgoster";
import { YonetimKullaniciKart_Screen } from "../screens/yonetimkullanicikart/yonetimkullanicikart";
import { TanimNakliyeSicaklikListe_Screen } from "../screens/tanimnakliyesicaklikliste/tanimnakliyesicaklikliste";
import { YuklemeListesiv2Detaylar_Screen } from "../screens/yuklemelistesiv2detaylar/yuklemelistesiv2detaylar";
import { ComponentTest_Screen } from "../screens/componenttest/componenttest";
import { SiparisListesiFullTruck_Screen } from "../screens/siparislistesifulltruck/siparislistesifulltruck";
import { ResetPassword_Screen } from "../screens/resetpassword/resetpassword";
import { YuklemePlanAracBeklemeListesi_Screen } from "../screens/yuklemeplanaracbeklemelistesi/yuklemeplanaracbeklemelistesi";
import { RaporFullTruckListe_Screen } from "../screens/raporfulltruckliste/raporfulltruckliste";
import { YuklemeListesiv2EvrakDetayTedarikci_Screen } from "../screens/yuklemelistesiv2evrakdetaytedarikci/yuklemelistesiv2evrakdetaytedarikci";



import LocalStorageService from "../auth/local-storage-service";
import { Redirect } from "../auth/redirect";
import { IAppMode, IAuthType } from "../bootstrapper";
import { NoMatch404 } from "../components/common/no-match-404";
import { Dashboard, ForgotPassword, Login, ResetPassword } from "../components/default_screens/index";
import { KuikaInfo } from "../components/default_screens/kuika-info";
import { MfeLogin } from "../components/mfe/mfe-login";
import { MsalLogin } from "../components/msal/msal-login";
import { MsalRedirect } from "../components/msal/msal-redirect";
import { NotificationRedirect } from "../components/notification/notification-redirect";
import { ScanCompareTest } from "../screens/scan-compare-test";
import { WFMailInteraction } from "../screens/wf-mail-interaction";
import confJson from "../shared/json/conf.json";
import { KMainFunctions } from "../shared/utilty/main-functions";
import { MasterScreenWrapper } from "./master-screen-wrapper";
import { PrivateRoute } from "./private-route";
import { Route } from "./route";



export interface IRouterState {}

export type IRouterType = "HashRouter" | "BrowserRouter";

export interface IRouterProps {
  authType: IAuthType;
  routerType?: IRouterType;
  external_access_token?: string;
  external_refresh_token?: string;
  external_user?: string;
  startingScreen?: string;
  appMode?: IAppMode;
  // Allow only screenInput_* props with specific typing
  [key: `screenInput_${string}`]: unknown;
}

declare let window: any;
export class Router extends React.Component<IRouterProps, IRouterState> {
  timerId: any = null;

  private hasNavigatedToStartingScreen: boolean = false;

  componentDidMount = () => {
    // SET LANGUAGE TO HTML BODY
    const lang = LocalStorageService.getUserLanguage();
    if (lang) {
      const fixedLangAttributeValue = lang.replace("_", "-");
      document.body.setAttribute("lang", fixedLangAttributeValue);
    }
    // Handle starting screen navigation for web component apps (only once)
    if (this.props.appMode === "WebComponent" && this.props.startingScreen && !this.hasNavigatedToStartingScreen) {
      this.hasNavigatedToStartingScreen = true;
      this.navigateToStartingScreen();
    }

    window.onfocus = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = true;
    };

    window.onblur = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = false;
    };

    if (!window.styler_speed) {
      window.styler_speed = 20;
    } else if (window.styler_speed < 500) {
      window.styler_speed += 100;
    }

    if (window?.kuika?.activeKuikaComponent !== undefined) {
      return;
    }
    const runTimeout = () => {
      this.timerId = setTimeout(() => {
        const allFormItems: NodeListOf<HTMLElement> = document.querySelectorAll(".kFormItem");
        if (allFormItems) {
          allFormItems.forEach((formItem) => {
            if (formItem.getAttribute("data-display-affected") === "true") {
              return;
            }
            const antFormItemControlInputContent: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input .ant-form-item-control-input-content"
            );
            const antFormItemControlInput: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input"
            );
            const antFormItemControl: HTMLElement = formItem.querySelector(".ant-form-item-control");

            if (
              antFormItemControlInputContent &&
              antFormItemControlInputContent.children &&
              antFormItemControlInputContent.children.length > 0
            ) {
              const formChild: HTMLElement = antFormItemControlInputContent.children[0] as HTMLElement;
              let calculatedDisplay: string = formChild.style.display;
              if (
                calculatedDisplay &&
                antFormItemControl &&
                antFormItemControlInput &&
                antFormItemControlInputContent
              ) {
                if (calculatedDisplay === "inline-flex" || calculatedDisplay === "inline-block") {
                  calculatedDisplay = "";
                  formItem.style.width = formChild.style.width ?? "auto";
                  formItem.style.display = "inline-block";
                  formItem.setAttribute("data-display-affected", "true");
                }
              }
            }
          });
        }
        this.componentDidMount();
      }, window.styler_speed);
    };

    runTimeout();

    setTimeout(() => {
      clearTimeout(this.timerId);
    }, 10000);
  };

  private getScreenInputPropKeys = (): string[] => {
    return Object.keys(this.props || {}).filter((k) => k && k.startsWith("screenInput_"));
  };

  private buildScreenInputsFromProps = (): Record<string, unknown> => {
    const screenInputs: Record<string, unknown> = {};
    this.getScreenInputPropKeys().forEach((key) => {
      const inputName = key.substring("screenInput_".length);
      screenInputs[inputName] = this.props[key];
    });
    return screenInputs;
  };

  private navigateToStartingScreen = () => {
    try {
      const screenName = this.props.startingScreen as string;
      const baseHash = screenName.startsWith("#") ? screenName : `#${screenName}`;
      const inputs = this.buildScreenInputsFromProps();
      const params = new URLSearchParams();

      Object.keys(inputs).forEach((k) => {
        const v = inputs[k];
        if (v !== undefined && v !== null) {
          params.append(k, typeof v === "string" ? v : JSON.stringify(v));
        }
      });

      const qs = params.toString();
      const hash = `${baseHash}${qs ? `?${qs}` : ""}`;

      if (window.location.hash !== hash) {
        window.location.hash = hash;
      }
    } catch (e) {
      console.error("Error navigating to starting screen:", e);
    }
  };

  render() {
    const KuikaRouter = this.KuikaRouter();
    return (
      <>
        <KuikaRouter>
          <Switch key="Switch">
                        <PrivateRoute exact path="/" component={HomePage_Screen} />
                        <PrivateRoute exact path="/tanimmusterinoktabilgikart" component={TanimMusteriNoktaBilgiKart_Screen} />
            <Route exact path="/parsiyelmusterisevkliste" component={ParsiyelMusteriSevkListe_Screen} />
            <Route exact path="/arunaloading" component={ArunaLoading_Screen} />
            <PrivateRoute exact path="/yonetimilcekart" component={YonetimIlceKart_Screen} />
            <PrivateRoute exact path="/leftmenuyukveren" component={LeftMenuYukVeren_Screen} />
            <PrivateRoute exact path="/tanimaractip" component={TanimAracTip_Screen} />
            <PrivateRoute exact path="/yuklemelistesiv2spotlistesi" component={YuklemeListesiv2SpotListesi_Screen} />
            <Route exact path="/tanimmusterinoktatanim" component={TanimMusteriNoktaTanim_Screen} />
            <PrivateRoute exact path="/yuklemelistesiv2evrakkontrol" component={YuklemeListesiv2EvrakKontrol_Screen} />
            <Route exact path="/tanimsurucutanim" component={TanimSurucuTanim_Screen} />
            <PrivateRoute exact path="/yonetimsehirkart" component={YonetimSehirKart_Screen} />
            <Route exact path="/yonetimsehirtanim" component={YonetimSehirTanim_Screen} />
            <Route exact path="/tanimyuklemeteslimnoktaliste" component={TanimYuklemeTeslimNoktaListe_Screen} />
            <PrivateRoute exact path="/yuklemebekleyenliste" component={YuklemeBekleyenListe_Screen} />
            <Route exact path="/tanimmusteritedarikcitanim" component={TanimMusteriTedarikciTanim_Screen} />
            <PrivateRoute exact path="/parsiyelaracyukleme" component={ParsiyelAracYukleme_Screen} />
            <PrivateRoute exact path="/yuklemelistesiv2detaytedarikci" component={YuklemeListesiv2DetayTedarikci_Screen} />
            <Route exact path="/yonetimkullanicitanim" component={YonetimKullaniciTanim_Screen} />
            <Route exact path="/teslimatyukle" component={TeslimatYukle_Screen} />
            <PrivateRoute exact path="/siparisdetayparsiyel" component={SiparisDetayParsiyel_Screen} />
            <PrivateRoute exact path="/yuklemelistesiv2ozet" component={YuklemeListesiv2Ozet_Screen} />
            <Route exact path="/tanimaractipliste" component={TanimAracTipListe_Screen} />
            <PrivateRoute exact path="/yuklemelistesiv2evrakkontroltedarikci" component={YuklemeListesiv2EvrakKontrolTedarikci_Screen} />
            <PrivateRoute exact path="/raporv2urunsevkiyatplan" component={Raporv2UrunSevkiyatPlan_Screen} />
            <PrivateRoute exact path="/yonetimilcetanim" component={YonetimIlceTanim_Screen} />
            <PrivateRoute exact path="/teslimyuklemetanim" component={TeslimYuklemeTanim_Screen} />
            <PrivateRoute exact path="/siparisparsiyeldetayv2" component={SiparisParsiyelDetayv2_Screen} />
            <PrivateRoute exact path="/raporftlmusteridetayli" component={RaporFTLMusteriDetayli_Screen} />
            <PrivateRoute exact path="/raporparsiyelyukleme" component={RaporParsiyelYukleme_Screen} />
            <PrivateRoute exact path="/siparislistesiparsiyel" component={SiparisListesiParsiyel_Screen} />
            <PrivateRoute exact path="/tanimmusteritedarikcibilgikart" component={TanimMusteriTedarikciBilgiKart_Screen} />
            <PrivateRoute exact path="/yuklemeolusturmasecimv2" component={YuklemeOlusturmaSecimv2_Screen} />
            <PrivateRoute exact path="/parsiyelmusterisevk" component={ParsiyelMusteriSevk_Screen} />
            <PrivateRoute exact path="/yuklemelistesiv2evrakdetay" component={YuklemeListesiv2EvrakDetay_Screen} />
            <PrivateRoute exact path="/yuklemeplanaracatama" component={YuklemePlanAracAtama_Screen} />
            <Route exact path="/tanimuruntanim" component={TanimUrunTanim_Screen} />
            <PrivateRoute exact path="/yuklemelistesi" component={YuklemeListesi_Screen} />
            <PrivateRoute exact path="/teslimatirsaliyebaglaexcel" component={TeslimatIrsaliyeBaglaExcel_Screen} />
            <Route exact path="/signin" component={this.LoginComponent()} />
            <Route exact path="/signin" component={Signin_Screen} />
            <PrivateRoute exact path="/homepage" component={HomePage_Screen} />
            <Route exact path="/yonetimulketanim" component={YonetimUlkeTanim_Screen} />
            <PrivateRoute exact path="/yuklemeolusturmaexcel" component={YuklemeOlusturmaExcel_Screen} />
            <PrivateRoute exact path="/yuklemelistesiv2" component={YuklemeListesiv2_Screen} />
            <PrivateRoute exact path="/tanimaracbilgikart" component={TanimAracBilgiKart_Screen} />
            <PrivateRoute exact path="/raporv2kantarfarkonay" component={Raporv2KantarFarkOnay_Screen} />
            <PrivateRoute exact path="/tanimsurucubilgikart" component={TanimSurucuBilgiKart_Screen} />
            <PrivateRoute exact path="/tanimurunkarti" component={TanimUrunKarti_Screen} />
            <PrivateRoute exact path="/leftmenu" component={LeftMenu_Screen} />
            <PrivateRoute exact path="/yonetimfirmakart" component={YonetimFirmaKart_Screen} />
            <PrivateRoute exact path="/siparislistesiparsiyelv2" component={SiparisListesiParsiyelv2_Screen} />
            <PrivateRoute exact path="/yuklemeteslimatbilgi" component={YuklemeTeslimatBilgi_Screen} />
            <PrivateRoute exact path="/tanimnakliyesicaklik" component={TanimNakliyeSicaklik_Screen} />
            <PrivateRoute exact path="/yuklemeplanaracislemleri" component={YuklemePlanAracIslemleri_Screen} />
            <Route exact path="/verificationcode" component={VerificationCode_Screen} />
            <PrivateRoute exact path="/raporv2mikrodagitim" component={Raporv2MikroDagitim_Screen} />
            <Route exact path="/yonetimfirmatanim" component={YonetimFirmaTanim_Screen} />
            <PrivateRoute exact path="/yuklemeplankantarfarklistesi" component={YuklemePlanKantarFarkListesi_Screen} />
            <PrivateRoute exact path="/raporv2tedarikciperformans" component={Raporv2TedarikciPerformans_Screen} />
            <PrivateRoute exact path="/raporltlmusteridetayli" component={RaporLTLMusteriDetayli_Screen} />
            <PrivateRoute exact path="/siparisdetayfulltruck" component={SiparisDetayFullTruck_Screen} />
            <PrivateRoute exact path="/raporltlmusteriildetayli" component={RaporLTLMusteriIlDetayli_Screen} />
            <Route exact path="/forgotpassword" component={ForgotPassword_Screen} />
            <PrivateRoute exact path="/parsiyelmusteridenmalkabul" component={ParsiyelMusteridenMalKabul_Screen} />
            <PrivateRoute exact path="/yonetimkullaniciekle" component={YonetimKullaniciEkle_Screen} />
            <PrivateRoute exact path="/yonetimulkekart" component={YonetimUlkeKart_Screen} />
            <PrivateRoute exact path="/homepagecopy" component={HomePagecopy_Screen} />
            <PrivateRoute exact path="/yuklemelistesiv2spotaktarimlistesi" component={YuklemeListesiv2SpotAktarimListesi_Screen} />
            <Route exact path="/parsiyelmusterisevklistedetay" component={ParsiyelMusteriSevkListeDetay_Screen} />
            <PrivateRoute exact path="/raporv2yuklemelisteozet" component={Raporv2YuklemeListeOzet_Screen} />
            <Route exact path="/signup" component={Signup_Screen} />
            <PrivateRoute exact path="/siparissevkemridetay" component={SiparisSevkEmriDetay_Screen} />
            <PrivateRoute exact path="/barkodlistesi" component={BarkodListesi_Screen} />
            <PrivateRoute exact path="/yuklemeplandetay" component={YuklemePlanDetay_Screen} />
            <PrivateRoute exact path="/yuklemeplanspotteklifver" component={YuklemePlanSpotTeklifVer_Screen} />
            <PrivateRoute exact path="/leftmenubos" component={LeftMenuBos_Screen} />
            <PrivateRoute exact path="/yuklemeplanspotteklifler" component={YuklemePlanSpotTeklifler_Screen} />
            <Route exact path="/tanimaractanim" component={TanimAracTanim_Screen} />
            <PrivateRoute exact path="/parsiyeldatmalkabul" component={ParsiyelDatMalKabul_Screen} />
            <PrivateRoute exact path="/mesajgoster" component={MesajGoster_Screen} />
            <PrivateRoute exact path="/yonetimkullanicikart" component={YonetimKullaniciKart_Screen} />
            <Route exact path="/tanimnakliyesicaklikliste" component={TanimNakliyeSicaklikListe_Screen} />
            <PrivateRoute exact path="/yuklemelistesiv2detaylar" component={YuklemeListesiv2Detaylar_Screen} />
            <PrivateRoute exact path="/componenttest" component={ComponentTest_Screen} />
            <PrivateRoute exact path="/siparislistesifulltruck" component={SiparisListesiFullTruck_Screen} />
            <Route exact path="/resetpassword" component={ResetPassword_Screen} />
            <PrivateRoute exact path="/yuklemeplanaracbeklemelistesi" component={YuklemePlanAracBeklemeListesi_Screen} />
            <PrivateRoute exact path="/raporfulltruckliste" component={RaporFullTruckListe_Screen} />
            <PrivateRoute exact path="/yuklemelistesiv2evrakdetaytedarikci" component={YuklemeListesiv2EvrakDetayTedarikci_Screen} />

            <Route path="/redirect" component={Redirect} />
            <Route path={"/login"} component={this.LoginComponent()} />
            
            
            <Route exact path="/forgotpassword" component={ForgotPassword} />
            <Route exact path="/resetpassword" component={ResetPassword} />
            <PrivateRoute exact path="/dashboard" component={Dashboard} />
            <Route exact path="/kuikainfo" component={KuikaInfo} />
            <Route exact path="/msalredirect" component={MsalRedirect} />
            <Route exact path="/wfmailinteraction" component={WFMailInteraction} />
            <PrivateRoute exact path="/scancomparetest" component={ScanCompareTest} />
            <Route exact path="/notificationredirect" component={NotificationRedirect} />
            <Route exact path="/logout" component={Redirect} />
            <Route path="*" component={NoMatch404} />
          </Switch>
        </KuikaRouter>
      </>
    );
  }

  KuikaRouter = () => {
    // Web component case
    let isWebComponentApp: any;
    isWebComponentApp = this.props.appMode === "WebComponent";
    if (
      confJson?.domainName !== undefined &&
      confJson?.applicationName !== undefined &&
      confJson?.applicationName !== "" &&
      window.kuika !== undefined &&
      window.kuika?.apps !== undefined &&
      window.kuika?.apps.length !== undefined &&
      window.kuika?.apps.length > 0
    ) {
      window.kuika?.apps.forEach((app: any) => {
        if (app.appName === confJson.applicationName && app.workspace === confJson.domainName) {
          isWebComponentApp = true;
        }
      });
    }
    if (window.kuika === undefined) {
      window.kuika = {};
    }
    window.kuika.isWebComponentApp = isWebComponentApp;

    if (isWebComponentApp === true || this.props.routerType === "HashRouter") {
      return (props: any) => {
        return <HashRouter key="HashRouter">{props.children}</HashRouter>;
      };
    }
    return (props: any) => {
      if (KMainFunctions.virtualDirectoryURL === "auto" || window?.location?.protocol === "file:") {
        return <BrowserRouter key="BrowserRouter">{props.children}</BrowserRouter>;
      }
      return (
        <BrowserRouter basename={KMainFunctions.virtualDirectoryURL} key="BrowserRouter">
          {props.children}
        </BrowserRouter>
      );
    };
  };

  LoginComponent = () => {
    if (this.props.authType === "MSAL") {
      return MsalLogin;
    }

    const { external_access_token } = this.props;
    const { external_refresh_token } = this.props;
    const { external_user } = this.props;
    // The host injects external_access_token as a short-lived MFE handoff JWT.
    // No refresh_token is involved — the microapp's own backend mints its
    // session cookies once the token is redeemed.
    if (external_access_token !== null && external_access_token !== undefined && external_access_token !== "") {
      return (props: any) => {
        return (
          <MfeLogin
            external_user={external_user}
            external_access_token={external_access_token}
            external_refresh_token={external_refresh_token}
          ></MfeLogin>
        );
      };
    }

    if (this.props.authType === "Kuika") {
      return Signin_Screen;
    }
    return <></>;
  };
}
